/* eslint-disable */
import ctype from 'component-type';

const expected = `number`;

/**
 * Check whether or not a given `item` is a Number
 * @param {any} item The `item` to check
 * @returns {boolean} Wheter or not the `item` is a indeed a Number
 */
const isNumber = (item) => ctype(item) === expected;

export default isNumber;
